<template>
  <div class="keyboard" v-show="visible">
    <div class="over" @click="close()"></div>
    <div class="content">
      <div class="top">
        <div class="animate-input">
          <div class="number" v-if="money !== '0'">{{money}}</div>
          <div v-else class="placeholder">每笔{{ text }}金额必须为{{stepSize}}的整数倍</div>
        </div>
        <div class="button" @click="close()">取消</div>
      </div>
      <div class="center">
        <div class="left">
          <div class="row" v-for="rowIndex in 3" :key="rowIndex">
            <div class="unit" v-for="colIndex in 3"
                 :key="(rowIndex -1) * 3 + colIndex"
                 @click="changeSize((rowIndex -1) * 3 + colIndex)"
            >
              {{(rowIndex -1) * 3 + colIndex}}
            </div>
          </div>
          <div class="row">
            <div class="unit" @click="changeSize(0)">
              0
            </div>
            <div class="unit" @click="changeSize(`+${stepSize}`, 'step')">
              +{{stepSize}}
            </div>
            <div class="unit" @click="changeSize(`-${stepSize}`, 'step')">
              -{{stepSize}}
            </div>
          </div>
        </div>
        <div class="right">
          <div class="top" @click="changeSize(-1)">
            <div class="mask"></div>
            <img :src="deleteImg" alt="clear">
          </div>
          <div class="bottom" @click="confirm()">
            确认
          </div>
        </div>
      </div>
      <div class="bottom"></div>
    </div>
  </div>
</template>

<script>
import deleteImg from './image/icon_delete.png'
export default {
  name: 'nd-keyboard',
  props: {
    // 步长
    stepSize: {
      type: Number,
      default: 500
    },
    // 起始金额
    startMoney: {
      type: Number,
      required: true
    },
    // 是否显示
    visible: {
      type: Boolean,
      required: true
    },
    text: {
      tyle: String,
      default: '提现'
    }
  },
  data () {
    return {
      money: '',
      deleteImg: deleteImg
    }
  },

  methods: {
    // 打开键盘时 初始化起始值
    init (value) {
      this.money = value.toString()
    },
    // 更改大小 0-9 +-500 退格
    changeSize (value, step) {
      if (step) {
        this.$emit('step')
      }
      if (/^[0-9]{1}$/.exec(value)) {
        // 0-9
        if (this.money === '0') {
          if (value === 0) {
            return false
          } else {
            this.money = value.toString()
          }
        } else {
          if (this.money.length === 10) return false
          this.money = this.money + value.toString()
        }
      } else if (value === -1) {
        // 退格
        if (this.money.length === 1) {
          if (this.money === '0') {
            return false
          } else {
            this.money = '0'
          }
        } else {
          this.money = this.money.slice(0, this.money.length - 1)
        }
      } else {
        // +-
        // eslint-disable-next-line
                    const result = eval(this.money + value)
        if (result <= 0) {
          this.money = '0'
        } else if (result >= 10000000000) {
          return false
        } else {
          this.money = result.toString()
        }
      }
    },

    // 确认按钮：并关闭键盘
    confirm () {
      this.$emit('changeResult', Number(this.money))
    },

    // 关闭键盘
    close () {
      // 无更改
      this.money = this.startMoney.toString()
      this.$emit('changeResult')
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/mixin.less";

    .keyboard {
        width: 100%;
        max-width: 10rem;
        height: 100vh;
        z-index: 9999;
        position: fixed;
        top: 0;
        .over {
            width: 100%;
            height: 100vh;
            background-color: rgba(0, 0, 0, 0.7);
        }
        .content {
            width: 100%;
            height: 618px;
            max-width: 10rem;
            position: fixed;
            bottom: 0;
            background-color: white;
            .top {
                width: 100%;
                height: 110px;
                background-color: #F5F5F5;
                display: flex;
                flex-direction: row;
                .animate-input {
                    background-color: #F5F5F5;
                    flex: 3;
                    padding-left: 50px;
                    text-align: left;
                    line-height: 90px;
                    .number {
                        height: 110px;
                        line-height: 110px;
                        display: inline-block;
                        color: #333333;
                        font-size: 50px;
                        font-family: JDZhengHT-Regular;
                        position: relative;
                        top: 3px;
                    }
                    .number:after {
                        content: '';
                        display: inline-block;
                        width: 5px;
                        height: 50px;
                        background-color: #FF4633;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        right: -8px;
                        animation: flash 1s ease-in-out infinite;
                    }
                    @keyframes flash {
                        from {
                            opacity: 1;
                        }
                        to {
                            opacity: 0;
                        }
                    }
                    .placeholder {
                        height: 110px;
                        line-height: 110px;
                        display: inline-block;
                        color: #CECECE;
                        font-size: 30px;
                        font-family: PingFang-SC-Regular;
                        position: relative;
                    }
                    .placeholder:before {
                        content: '';
                        display: inline-block;
                        width: 3px;
                        height: 43px;
                        border-radius: 2px;
                        background-color: #FF4633;
                        position: relative;
                        top: 10px;
                        animation: flash 1s ease-in-out infinite;
                    }
                }
                .button {
                    flex: 1;
                    height: 110px;
                    line-height: 110px;
                    color: rgba(153,153,153,1);
                    font-family: PingFang-SC-Regular;
                    font-size: 32px;
                    text-align: center;
                }
            }
            .center {
                height: 427px;
                display: flex;
                flex-direction: row;
                .left {
                    display: flex;
                    flex: 3;
                    flex-direction: column;
                    .row {
                        flex: 1;
                        display: flex;
                        flex-direction: row;
                        .unit {
                            flex: 1;
                            text-align: center;
                            font-size: 40px;
                            font-family: JDZhengHT-Regular;
                            color: #333333;
                            line-height: 98px;
                            height: 97px;
                            border-bottom: 1px solid rgba(233, 233, 233, 1);
                            border-right: 1px solid rgba(233, 233, 233, 1);
                        }
                    }
                    .row:nth-last-child(1) {
                        .unit {
                            border-bottom: none;
                        }
                    }
                }
                .right {
                    display: flex;
                    flex: 1;
                    flex-direction: column;
                    .top {
                        flex: 1;
                        display: block;
                        height: 195px;
                        text-align: center;
                        line-height: 195px;
                        background-color: white;
                        border-bottom: 1px solid rgba(233, 233, 233, 1);
                        position: relative;
                        .mask {
                            width: 100%;
                            height: 100%;
                            z-index: 100;
                            position: absolute;
                            top: 0;
                            left: 0;
                        }
                        img {
                            width: 60px;
                            z-index: 99;
                        }
                    }
                    .bottom {
                        display: block;
                        flex: 1;
                        text-align: center;
                        line-height: 195px;
                        color: #FF4633;
                        font-family: PingFang-SC-Medium,PingFang SC;
                        font-size: 36px;
                        font-weight:500;
                    }
                }
            }
            > .bottom {
                width: 100%;
                height: 80px;
                background-color: #F7F7F7;
            }
        }
    }
</style>
